import { NgModule } from "@angular/core";
import { ClickOutDirective } from "./click-outside.directive";
import { CheckCookiesExpiredDirective } from "./check-cookies-expired.directive";
import { GmapAutocompleteDirective } from "./gmap-autocomplete.directive";
import { CountdownDirective } from "./countdown.directive";
import { TextCutDirective } from "./text-cut.directive";
import { FormatNumberDirective } from "./format-number.directive";
import { HorizontalScroll } from "./horizontal-scroll.directive";
import { FromWeiDirective } from "./from-wei.directive";

@NgModule({
    declarations: [
        ClickOutDirective,
        CheckCookiesExpiredDirective,
        GmapAutocompleteDirective,
        CountdownDirective,
        TextCutDirective,
        FormatNumberDirective,
        HorizontalScroll,
        FromWeiDirective
    ],
    imports: [
    ],
    exports: [
        ClickOutDirective,
        CheckCookiesExpiredDirective,
        GmapAutocompleteDirective,
        CountdownDirective,
        TextCutDirective,
        FormatNumberDirective,
        HorizontalScroll,
        FromWeiDirective
    ]
})

export class DirectivesModule { }